__turbopack_context__.v({
  "allBtn": "ParagraphRealizationsTestimonials-module__swXKzW__allBtn",
  "allWrap": "ParagraphRealizationsTestimonials-module__swXKzW__allWrap",
  "author": "ParagraphRealizationsTestimonials-module__swXKzW__author",
  "authorName": "ParagraphRealizationsTestimonials-module__swXKzW__authorName",
  "authorSector": "ParagraphRealizationsTestimonials-module__swXKzW__authorSector",
  "authorSep": "ParagraphRealizationsTestimonials-module__swXKzW__authorSep",
  "card": "ParagraphRealizationsTestimonials-module__swXKzW__card",
  "cardBody": "ParagraphRealizationsTestimonials-module__swXKzW__cardBody",
  "cardCta": "ParagraphRealizationsTestimonials-module__swXKzW__cardCta",
  "cardImg": "ParagraphRealizationsTestimonials-module__swXKzW__cardImg",
  "cardImgPlaceholder": "ParagraphRealizationsTestimonials-module__swXKzW__cardImgPlaceholder",
  "cardLabel": "ParagraphRealizationsTestimonials-module__swXKzW__cardLabel",
  "cardLogo": "ParagraphRealizationsTestimonials-module__swXKzW__cardLogo",
  "cardMedia": "ParagraphRealizationsTestimonials-module__swXKzW__cardMedia",
  "cardSector": "ParagraphRealizationsTestimonials-module__swXKzW__cardSector",
  "cardTitle": "ParagraphRealizationsTestimonials-module__swXKzW__cardTitle",
  "eyebrow": "ParagraphRealizationsTestimonials-module__swXKzW__eyebrow",
  "grid": "ParagraphRealizationsTestimonials-module__swXKzW__grid",
  "header": "ParagraphRealizationsTestimonials-module__swXKzW__header",
  "heading": "ParagraphRealizationsTestimonials-module__swXKzW__heading",
  "pagination": "ParagraphRealizationsTestimonials-module__swXKzW__pagination",
  "root": "ParagraphRealizationsTestimonials-module__swXKzW__root",
  "slide": "ParagraphRealizationsTestimonials-module__swXKzW__slide",
  "swiper": "ParagraphRealizationsTestimonials-module__swXKzW__swiper",
  "testimonial": "ParagraphRealizationsTestimonials-module__swXKzW__testimonial",
  "testimonialsBlock": "ParagraphRealizationsTestimonials-module__swXKzW__testimonialsBlock",
});
